import Swiper from 'swiper';
import 'swiper/css';

const swiper = new Swiper('[data-box="swiper-steps"]', {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: 1.11708,
  loop: false,
  spaceBetween: 16,
});
